import React from 'react';
import { Grid, Box } from '@mui/material';

const HalfByHalf = ({
  src,
  direction,
  alt = 'Image',
  children,
  ratio = [1, 1],
  minHeight = '300px',
  contain = false,
  fullHeightImage = false,
  mobileOverlay = false,
}) => {
  const safeRatio =
    Array.isArray(ratio) && ratio.length === 2 && ratio.every(n => typeof n === 'number' && n > 0)
      ? ratio
      : [1, 1];

  const childrenArr = React.Children.toArray(children);
  const mobileHeader = childrenArr[0] ?? null;
  const mobileBody = childrenArr.length > 1 ? childrenArr.slice(1) : null;

  return (
    <>
      <Grid
        container
        spacing={0}
        sx={{
            my:'5rem',
          flexDirection: {
            xs: 'column', // Na mniejszych ekranach układ w kolumnie (jedno pod drugim)
            lg: direction === 'left' ? 'row' : 'row-reverse', // Na większych ekranach zmieniamy kolejność na podstawie direction
          },
        }}
      >
        {/* Mobile order: header -> image -> body (unless mobileOverlay) */}
        {!mobileOverlay && (
          <Grid item xs={12} sx={{ display: { xs: 'block', lg: 'none' } }}>
            <Box sx={{ px: '2rem' }}>{mobileHeader}</Box>
          </Grid>
        )}

        {/* Image */}
        <Grid item xs={12} lg={Math.round((12 * safeRatio[0]) / (safeRatio[0] + safeRatio[1]))}>
          <Box
            role="img"
            aria-label={alt}
            sx={{
              width: '100%',
              height: fullHeightImage ? '100%' : 'auto',
              backgroundImage: `url(${src})`,
              backgroundSize: contain ? 'contain' : 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              minHeight: fullHeightImage ? '100%' : minHeight,
              padding: '0',
              position: mobileOverlay ? 'relative' : 'static',
            }}
          >
            {mobileOverlay && (
              <Box
                sx={{
                  position: 'absolute',
                  left: '1rem',
                  top: '1rem',
                  bottom: '1rem',
                  display: { xs: 'flex', lg: 'none' },
                  alignItems: 'center',
                  maxWidth: '85%',
                }}
              >
                {children}
              </Box>
            )}
          </Box>
        </Grid>

        {/* Content */}
        <Grid item xs={12} lg={12 - Math.round((12 * safeRatio[0]) / (safeRatio[0] + safeRatio[1]))}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              height: '100%', // Zapewnia dopasowanie wysokości
              px: { xs: '0', lg: '2rem' }, 
            }}
          >
            <Box sx={{ display: { xs: 'none', lg: 'block' } }}>{children}</Box>
            {!mobileOverlay && <Box sx={{ display: { xs: 'block', lg: 'none' } }}>{mobileBody}</Box>}
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default HalfByHalf;

